import { IPaymentCard } from "@wingspanhq/payments/dist/interfaces";
import toLower from "lodash/toLower";

export const selectorPaymentCardPayoutReady = (paymentCard: IPaymentCard) => {
  if (isWingspanIssuedCard(paymentCard)) {
    return false;
  }

  if (isDiscoverCard(paymentCard)) {
    return false;
  }

  return true;
};

// `issuer` and `brand` are declared as required, but incomplete card
// registrations can leave them unset on the record. Use `toLower` (null-safe)
// so an unknown issuer/brand is treated as "not Wingspan"/"not Discover"
// instead of throwing and taking down the whole payout methods page.
function isWingspanIssuedCard(paymentCard: IPaymentCard) {
  return toLower(paymentCard.issuer) === "wingspan";
}

function isDiscoverCard(paymentCard: IPaymentCard) {
  return toLower(paymentCard.brand) === "discover";
}
